import { Icon, IconType } from '@platform/ui-library';
import { FC, ReactNode } from 'react';
import { NotificationType } from '../../types';
import styles from './notification-message.module.scss';

const typeToIcon: Record<NotificationType, IconType> = {
  [NotificationType.error]: 'errorColor',
  [NotificationType.info]: 'infoColor',
  [NotificationType.success]: 'successColor',
  [NotificationType.warning]: 'warningColor'
};

export type NotificationMessageProps = {
  children: ReactNode;
  type: NotificationType;
};

export const NotificationMessage: FC<NotificationMessageProps> = ({
  children,
  type
}) => {
  const icon = typeToIcon[type];

  return (
    <p className={styles.container}>
      {(!icon) ? null : (
        <Icon icon={icon} />
      )}
      <span>{children}</span>
    </p>
  );
};
